export class AddDeviceRequestViewModel {
	public name: string;
	public structureId: string;
	public deviceId: string;
	public parentDeviceId: string;
	public deviceTypeId: string;
}